var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stopwatch",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-buttons",
    d: "M35 12.0312V9.84375M18.0469 18.0469L16.4062 16.4062",
    stroke: "#1422BD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-circle",
    d: "M35 13.125C30.2409 13.125 25.5887 14.5362 21.6316 17.1803C17.6745 19.8243 14.5904 23.5823 12.7692 27.9792C10.9479 32.376 10.4714 37.2142 11.3999 41.8819C12.3283 46.5495 14.6201 50.8371 17.9853 54.2023C21.3505 57.5675 25.638 59.8592 30.3057 60.7876C34.9733 61.7161 39.8115 61.2396 44.2083 59.4183C48.6052 57.5971 52.3632 54.513 55.0073 50.5559C57.6513 46.5989 59.0625 41.9466 59.0625 37.1875C59.0625 30.8057 56.5274 24.6853 52.0148 20.1727C47.5022 15.6601 41.3818 13.125 35 13.125Z",
    stroke: "#1422BD",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-big-arrow",
    d: "M35 31.7188V20.7812",
    stroke: "#1422BD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-small-circle",
    d: "M35 41.5625C37.4162 41.5625 39.375 39.6037 39.375 37.1875C39.375 34.7713 37.4162 32.8125 35 32.8125C32.5838 32.8125 30.625 34.7713 30.625 37.1875C30.625 39.6037 32.5838 41.5625 35 41.5625Z",
    stroke: "#1422BD",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-small-arrow",
    d: "M35 31.7188V24.7812",
    stroke: "#1422BD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "stopwatch-small-circle",
    d: "M35 41.5625C37.4162 41.5625 39.375 39.6037 39.375 37.1875C39.375 34.7713 37.4162 32.8125 35 32.8125C32.5838 32.8125 30.625 34.7713 30.625 37.1875C30.625 39.6037 32.5838 41.5625 35 41.5625Z",
    stroke: "#1422BD",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.5ab510e8d6fff85d5a422abb0895c43e.svg";
export { ForwardRef as ReactComponent };